import { SyntheticEvent } from "react";
import { SlopedRoofLayers } from "@iko-design-center/shared";
import { useTranslation } from "react-i18next";
import {
  allSelectedDownloadState,
  getLayerOptions,
} from "../../../store/sloped-roof/download";
import { useSlopedRoof } from "../../../store/sloped-roof/hooks";
import { useModal } from "../../../store/modal/hooks";

type ToggleAllOptions = "DOP" | "technicalFiche";

export function useDownload() {
  const { setDownloadState, downloadState } = useSlopedRoof();
  const { closeModal, displaySlopedRoofDownloadMailModal } = useModal();
  const { t } = useTranslation();

  function selectAll() {
    setDownloadState(allSelectedDownloadState);
  }

  function handleCardClick(e: SyntheticEvent) {
    e.stopPropagation();
  }

  const technicalFicheOptions = getLayerOptions({
    t,
    state: downloadState.technicalFiche,
  });
  const DOPOptions = getLayerOptions({
    t,
    state: downloadState.DOP,
  });

  function toggleAll(kind: ToggleAllOptions) {
    switch (kind) {
      case "technicalFiche":
        const technicalFicheChecked =
          downloadState.technicalFiche.roofType &&
          downloadState.technicalFiche.roofInsulation;

        setDownloadState({
          ...downloadState,
          technicalFiche: {
            roofType: !technicalFicheChecked,
            roofInsulation: !technicalFicheChecked,
          },
        });
        break;
      case "DOP":
        const DOPChecked =
          downloadState.DOP.roofType &&
          downloadState.DOP.roofInsulation;

        setDownloadState({
          ...downloadState,
          DOP: {
            roofType: !DOPChecked,
            roofInsulation: !DOPChecked,
          },
        });
        break;
    }
  }

  function toggleLayersOption(kind: ToggleAllOptions, value: SlopedRoofLayers) {
    switch (kind) {
      case "technicalFiche":
        setDownloadState({
          ...downloadState,
          technicalFiche: {
            ...downloadState.technicalFiche,
            [value]: !downloadState.technicalFiche[value],
          },
        });
        break;
      case "DOP":
        setDownloadState({
          ...downloadState,
          DOP: {
            ...downloadState.DOP,
            [value]: !downloadState.DOP[value],
          },
        });
        break;
    }
  }

  function toggle(
    kind:
      | "specifications"
      | "BIMFile"
      | "screenshots"
      | "thermalCalculation"
      | "processingGuideline"
  ) {
    setDownloadState({
      ...downloadState,
      [kind]: !downloadState[kind],
    });
  }

  function handleDownload() {
    displaySlopedRoofDownloadMailModal();
  }

  return {
    t,
    handleCardClick,
    closeModal,
    selectAll,
    technicalFicheOptions,
    toggleAll,
    toggleLayersOption,
    DOPOptions,
    downloadState,
    toggle,
    handleDownload,
  };
}
